import type { IUserTableFilters } from 'src/types/user';
import type { UseSetStateReturn } from 'minimal-shared/hooks';

import { TableToolbarView } from './table-toolbar-view';
import { useTableToolbarLogic } from '../../hooks/use-table-toolbar-logic';

// ----------------------------------------------------------------------

type Props = {
  onResetPage: () => void;
  filters: UseSetStateReturn<IUserTableFilters>;
  options: { roles: string[] };
  actionButtonLabel: string;
  actionButtonHandler?: () => void;
  actionButtonIcon?: string;
  secondaryActionButtonLabel?: string;
  secondaryActionButtonHandler?: () => void;
  secondaryActionButtonIcon?: string;
  isToolbarVisible: boolean;
  isActionButton?: Array<'import' | 'export'>;
  actionhref?: string;
  isShowCreateBtn?: boolean;
  isSearchFullWidth?: boolean;
  onFileSelect?: (data: { file: File; content: string }) => void;
  onExportContact?: () => void;
  currentModule?: string;
  moduleName?: string;
  isCreate: boolean;
  isView: boolean;
  isImport: boolean;
  isExport: boolean;
  advanceFilterFields?: any;
  setAdvanceFilter?: any;
  isAdvanceFilter?: boolean;
  advanceFilters?: any;
  refreshPage?: () => void;
  refreshing?: boolean;
  resetPagination?: any;
  isDisableSync?: boolean;
  isSearchInput?: boolean;
  selectedfilters?: any;
  handleRemoveAllFilter?: () => void;
  dateTimeFiltre?: any;
  isPrivacyPolicyUrls?: {
    message: string;
    links: { label: string; url: string }[];
  } | null;
  columns?: any[];
  allColumns?: any[]; // All columns including hidden ones
  visibleColumns?: string[];
  setVisibleColumns?: React.Dispatch<React.SetStateAction<string[]>>;
  customFields?: any[];
};

// ----------------------------------------------------------------------

export function TableToolbar(props: Props) {
  // Use the logic hook
  const logic = useTableToolbarLogic({
    filters: props.filters,
    onResetPage: props.onResetPage,
    columns: props.columns,
    allColumns: props.allColumns, // Pass all columns for the dropdown
    visibleColumns: props.visibleColumns,
    setVisibleColumns: props.setVisibleColumns,
    onFileSelect: props.onFileSelect,
    onExportContact: props.onExportContact,
  });

  // Pass all props to the view component
  return <TableToolbarView {...props} {...logic} />;
}
